export const statuses = {
    'unreviewed' : 'Unreviewed',
    'in_progress' : 'In Progress',
    'completed' : 'Completed',
    'converted' : 'Converted',
    'rejected' : 'Rejected',
}

export const publicStatuses = {
    'in_review' : 'In Review',
    'approved' : 'Approved',
    'rejected' : 'Rejected',
    'private' : 'Private',
}

export const startupStatusLabels = {
    unreviewed: 'In Review',
    liked: 'Accepted',
    disliked: 'Rejected',
    escalated: 'Escalated',
};

export const startupStatusClasses = {
    unreviewed: 'status-plate--unreviewed',
    liked: '',
    disliked: 'status-plate--rejected',
    escalated: 'status-plate--evaluate',
};
